export default "__VITE_ASSET__BntmbPpz__"